import { Label } from "../ui/label";
import { AREAS, RESTAURANTS } from "../../constants";

function PillButton({ active, disabled, onClick, children }) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={`h-9 px-4 rounded-full text-sm border transition-colors ${
        active
          ? "bg-[#0B1F3A] text-white border-[#0B1F3A]"
          : "bg-white text-[#0B1F3A] border-[#E6E0D4] hover:border-[#0B1F3A]/40"
      } ${disabled ? "opacity-40 cursor-not-allowed" : ""}`}
    >
      {children}
    </button>
  );
}

export default function ProductAssignment({
  assignedRestaurants,
  assignedAreas,
  canPickAnyRestaurant,
  userRestaurant,
  onToggleRestaurant,
  onToggleArea,
}) {
  return (
    <>
      <div>
        <Label className="text-[10.5px] tracking-eyebrow uppercase text-[#0B1F3A]/60">Assigned restaurants</Label>
        <div className="mt-2 flex flex-wrap gap-2">
          {RESTAURANTS.map((r) => (
            <PillButton
              key={r.id}
              active={assignedRestaurants?.includes(r.id)}
              disabled={!canPickAnyRestaurant && r.id !== userRestaurant}
              onClick={() => onToggleRestaurant(r.id)}
            >
              {r.name}
            </PillButton>
          ))}
        </div>
      </div>
      <div>
        <Label className="text-[10.5px] tracking-eyebrow uppercase text-[#0B1F3A]/60">Assigned areas</Label>
        <div className="mt-2 flex flex-wrap gap-2">
          {AREAS.map((a) => (
            <PillButton
              key={a.id}
              active={assignedAreas?.includes(a.id)}
              onClick={() => onToggleArea(a.id)}
            >
              {a.name}
            </PillButton>
          ))}
        </div>
        {assignedAreas?.length === 0 && (
          <p className="text-xs text-[#0B1F3A]/55 mt-1">
            Tip: assign to at least one area so employees can see it.
          </p>
        )}
      </div>
    </>
  );
}
